var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!isNaN(_vm.value) && Number.isFinite(_vm.value))?_c('fin-percentage-change',_vm._b({attrs:{"change":_vm.value}},'fin-percentage-change',_vm.header.componentProps,false)):_c('span',[_vm._v("-")])}
var staticRenderFns = []

export { render, staticRenderFns }